import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: '#000000',
  width: '100%',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  bottom: 0,
  left: 0,
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <Container maxWidth="lg">
        <Stack
          direction="row"
          spacing={4}
          justifyContent="center"
          alignItems="center"
        >
          <FooterLink href="/">Home</FooterLink>
          <FooterLink href="/contact">Contact Us</FooterLink>
          <Typography color="text.secondary">
            {new Date().getFullYear()} Wise Friend. All rights reserved.
          </Typography>
          <FooterLink href="/privacy">Privacy Policy</FooterLink>
          <FooterLink href="/terms">Terms of Service</FooterLink>
        </Stack>
      </Container>
    </StyledFooter>
  );
};